import { FC, lazy, Suspense, SyntheticEvent, useState } from 'react';
import { IconButton } from '@mui/material';
import { Face as FaceIcon } from '@mui/icons-material';

const ProfileContent = lazy(() =>
  import(/* webpackChunkName: "ProfileContent" */ './ProfileContent').then((module) => ({
    default: module.ProfileContent,
  }))
);

export const Profile: FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>();
  const isOpen = Boolean(anchorEl);
  const handleOpen = (event: SyntheticEvent) => {
    const target = event.currentTarget as HTMLButtonElement;
    setAnchorEl(target);
  };

  const handleClose = (event?: unknown) => {
    if ((event as SyntheticEvent & { metaKey?: boolean })?.metaKey) {
      return;
    }
    setAnchorEl(undefined);
  };

  return (
    <>
      <IconButton
        color='inherit'
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup='true'
        aria-label='Profile section'
        onClick={handleOpen}
        size='large'
      >
        <FaceIcon />
      </IconButton>
      {isOpen && (
        <Suspense>
          <ProfileContent anchorEl={anchorEl} handleClose={handleClose} />
        </Suspense>
      )}
    </>
  );
};
